import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../components/ui/dialog';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Label } from '../../components/ui/label';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Checkbox } from '../../components/ui/checkbox';
import { ScrollArea } from '../../components/ui/scroll-area';
import { 
  Building2, Plus, Loader2, User, Phone, Mail, Briefcase, Trash2, Edit, X, ChevronLeft,
  FileText, Calendar, ClipboardList, Package, Receipt, FileSignature, Upload, Eye, Send, Download,
  FileBarChart, ArrowRightLeft, Users, ChevronRight, Sun, CloudSun, CheckCircle
} from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('fortis_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const BranchSubcontractors = ({ branchIdOverride, readOnly = false }) => {
  const { user } = useAuth();
  const [subcontractors, setSubcontractors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  // const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedSubcontractor, setSelectedSubcontractor] = useState(null);
  const [detailView, setDetailView] = useState(false);
  const [activeTab, setActiveTab] = useState('hakedis');
  
  // Badge/Yeni sayaç sistemi
  const [newCounts, setNewCounts] = useState({ subcontractors: {}, total_new: 0 });
  
  // Tab data states
  const [hakedisData, setHakedisData] = useState([]);
  const [sozlesmeData, setSozlesmeData] = useState([]);
  const [isProgramiData, setIsProgramiData] = useState([]);
  const [tutanakData, setTutanakData] = useState([]);
  const [isBilgisiData, setIsBilgisiData] = useState([]);
  const [personelData, setPersonelData] = useState({ employees: [], total_count: 0, sabah_count: 0, ogle_count: 0, bildirim_yok_count: 0, date: '' });
  const [personelDate, setPersonelDate] = useState(new Date().toISOString().split('T')[0]);
  const [tabLoading, setTabLoading] = useState(false);
  
  // Modal states for each tab
  const [hakedisModalOpen, setHakedisModalOpen] = useState(false);
  const [sozlesmeModalOpen, setSozlesmeModalOpen] = useState(false);
  const [isProgramiModalOpen, setIsProgramiModalOpen] = useState(false);
  const [tutanakModalOpen, setTutanakModalOpen] = useState(false);
  const [isBilgisiModalOpen, setIsBilgisiModalOpen] = useState(false);
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  
  // Form states
  const [formData, setFormData] = useState({
    company_name: '',
    company_duties: '',
    contacts: [{ name: '', title: '', phone: '', email: '' }],
    start_date: '',
    end_date: '',
    provided_service: '',
    custom_fields: [], // { key: '', value: '' }
    visible_to_users: [],  // Bu taşeronu görebilecek kullanıcılar
    contract_viewers: []   // Sözleşme tabını görebilecek kullanıcılar
  });
  
  // İş Paneli kullanıcıları
  const [workPanelUsers, setWorkPanelUsers] = useState([]);
  
  const [hakedisForm, setHakedisForm] = useState({
    hakedis_date: new Date().toISOString().split('T')[0],
    title: '',
    amount: '',
    description: '',
    documents: []
  });
  
  const [sozlesmeForm, setSozlesmeForm] = useState({
    contract_date: new Date().toISOString().split('T')[0],
    work_type: '',
    start_date: '',
    end_date: '',
    documents: []
  });
  
  const [isProgramiForm, setIsProgramiForm] = useState({
    subject: '',
    description: '',
    start_date: '',
    end_date: '',
    documents: []
  });
  
  const [tutanakForm, setTutanakForm] = useState({
    report_date: new Date().toISOString().split('T')[0],
    title: '',
    content: '',
    description: '',
    documents: []
  });
  
  const [isBilgisiForm, setIsBilgisiForm] = useState({
    report_date: new Date().toISOString().split('T')[0],
    title: '',
    content: '',
    description: '',
    documents: []
  });
  
  // Malzeme Kullanımı states
  const [malzemeData, setMalzemeData] = useState([]);
  const [depoMalzemeleri, setDepoMalzemeleri] = useState([]); // Depodan verilen malzemeler
  
  // Taşınan Raporlar states
  const [tasinanRaporlarData, setTasinanRaporlarData] = useState([]);
  const [malzemeModalOpen, setMalzemeModalOpen] = useState(false);
  const [malzemeForm, setMalzemeForm] = useState({
    usage_date: new Date().toISOString().split('T')[0],
    material_name: '',
    quantity: '',
    unit: 'adet',
    description: '',
    documents: []
  });
  
  // Forward (İlet) states
  const [forwardModalOpen, setForwardModalOpen] = useState(false);
  const [forwardTarget, setForwardTarget] = useState('muhasebe');
  const [forwardNote, setForwardNote] = useState('');
  const [forwardingItem, setForwardingItem] = useState(null);
  const [isForwarding, setIsForwarding] = useState(false);

  // Get current user's branch_id from localStorage
  const getUserBranchId = () => {
    try {
      const userStr = localStorage.getItem('fortis_user');
      if (userStr) {
        const user = JSON.parse(userStr);
        return user.branch_id;
      }
    } catch (e) {
      console.error('Error getting user branch_id:', e);
    }
    return null;
  };

  useEffect(() => {
    loadSubcontractors();
    loadNewCounts();
    loadWorkPanelUsers();
  }, []);

  const loadWorkPanelUsers = async () => {
    try {
      const res = await axios.get(`${API}/work/panel-users`, { headers: getAuthHeaders() });
      setWorkPanelUsers(res.data || []);
    } catch (error) {
      console.error('İş paneli kullanıcıları yüklenirken hata:', error);
    }
  };

  useEffect(() => {
    if (selectedSubcontractor && detailView) {
      loadTabData(activeTab);
      // Sekme değişince mark-seen çağır
      markTabSeen(selectedSubcontractor.id, activeTab);
    }
  }, [selectedSubcontractor, activeTab, detailView]);

  // Yeni kayıt sayılarını yükle
  const loadNewCounts = async () => {
    try {
      const res = await axios.get(`${API}/branch/subcontractors/new-counts`, { headers: getAuthHeaders() });
      setNewCounts(res.data || { subcontractors: {}, total_new: 0 });
    } catch (error) {
      console.error('Yeni sayılar yüklenemedi:', error);
    }
  };

  // Sekme görüldü olarak işaretle
  const markTabSeen = async (subcontractorId, tab) => {
    try {
      // Tab name mapping
      const tabMap = {
        'hakedis': 'hakedis',
        'sozlesme': 'sozlesme',
        'is-programi': 'is-programi',
        'tutanaklar': 'tutanaklar',
        'is-bilgisi': 'is-bilgisi',
        'malzeme-kullanimi': 'malzeme',
        'tasinan-raporlar': 'raporlar'
      };
      const apiTab = tabMap[tab] || tab;
      
      await axios.post(`${API}/branch/subcontractors/mark-seen`, 
        { subcontractor_id: subcontractorId, tab: apiTab },
        { headers: getAuthHeaders() }
      );
      // Sayaçları güncelle
      setTimeout(() => loadNewCounts(), 500);
    } catch (error) {
      console.error('Mark seen hatası:', error);
    }
  };

  // Taşeronun yeni kayıt sayısını al
  const getSubcontractorNewCount = (subId) => {
    return newCounts.subcontractors?.[subId]?.total || 0;
  };

  // Sekmenin yeni kayıt sayısını al
  const getTabNewCount = (subId, tab) => {
    const tabMap = {
      'hakedis': 'hakedis',
      'sozlesme': 'sozlesme',
      'is-programi': 'is-programi',
      'tutanaklar': 'tutanaklar',
      'is-bilgisi': 'is-bilgisi',
      'malzeme-kullanimi': 'malzeme',
      'tasinan-raporlar': 'raporlar'
    };
    const apiTab = tabMap[tab] || tab;
    return newCounts.subcontractors?.[subId]?.tabs?.[apiTab] || 0;
  };

  const loadSubcontractors = async () => {
    setLoading(true);
    try {
      const branchId = getUserBranchId();
      const url = branchId 
        ? `${API}/branch/subcontractors?branch_id=${branchId}`
        : `${API}/branch/subcontractors`;
      const res = await axios.get(url, { headers: getAuthHeaders() });
      setSubcontractors(res.data || []);
    } catch (error) {
      console.error('Taşeronlar yüklenirken hata:', error);
      toast.error('Taşeronlar yüklenemedi');
    }
    setLoading(false);
  };

  const loadTabData = useCallback(async (tab) => {
    if (!selectedSubcontractor) return;
    setTabLoading(true);
    try {
      const endpoints = {
        'hakedis': `/branch/subcontractors/${selectedSubcontractor.id}/hakedis`,
        'sozlesme': `/branch/subcontractors/${selectedSubcontractor.id}/sozlesme`,
        'is-programi': `/branch/subcontractors/${selectedSubcontractor.id}/is-programi`,
        'tutanaklar': `/branch/subcontractors/${selectedSubcontractor.id}/tutanaklar`,
        'is-bilgisi': `/branch/subcontractors/${selectedSubcontractor.id}/is-bilgisi`,
        'malzeme-kullanimi': `/branch/subcontractors/${selectedSubcontractor.id}/malzeme-kullanimi`,
        'tasinan-raporlar': `/branch/subcontractors/${selectedSubcontractor.id}/reports`,
        'personel': `/work/subcontractors/${selectedSubcontractor.id}/personel?date=${personelDate}`
      };
      
      if (endpoints[tab]) {
        const res = await axios.get(`${API}${endpoints[tab]}`, { headers: getAuthHeaders() });
        switch(tab) {
          case 'hakedis': setHakedisData(res.data || []); break;
          case 'sozlesme': setSozlesmeData(res.data || []); break;
          case 'is-programi': setIsProgramiData(res.data || []); break;
          case 'tutanaklar': setTutanakData(res.data || []); break;
          case 'is-bilgisi': setIsBilgisiData(res.data || []); break;
          case 'personel': setPersonelData(res.data || { employees: [], total_count: 0 }); break;
          case 'malzeme-kullanimi': 
            setMalzemeData(res.data || []); 
            // Depodan verilen malzemeleri de yükle
            try {
              const depoRes = await axios.get(`${API}/branch/subcontractors/${selectedSubcontractor.id}/depo-malzemeleri`, { headers: getAuthHeaders() });
              setDepoMalzemeleri(depoRes.data || []);
            } catch (depoErr) {
              console.error('Depo malzemeleri yüklenemedi:', depoErr);
              setDepoMalzemeleri([]);
            }
            break;
          case 'tasinan-raporlar': setTasinanRaporlarData(res.data || []); break;
        }
      }
    } catch (error) {
      console.error(`${tab} verileri yüklenirken hata:`, error);
    }
    setTabLoading(false);
  }, [selectedSubcontractor, personelDate]);

  // Personel tarihi değiştiğinde yeniden yükle
  const handlePersonelDateChange = (newDate) => {
    setPersonelDate(newDate);
    if (activeTab === 'personel') {
      loadTabData('personel');
    }
  };

  const resetForm = () => {
    setFormData({
      company_name: '',
      company_duties: '',
      contacts: [{ name: '', title: '', phone: '', email: '' }],
      start_date: '',
      end_date: '',
      provided_service: '',
      custom_fields: [],
      visible_to_users: [],
      contract_viewers: []
    });
  };

  const handleFileUpload = async (e, setFormFunc, formKey) => {
    const files = e.target.files;
    if (!files.length) return;
    
    const newDocs = [];
    for (const file of files) {
      const reader = new FileReader();
      reader.onload = () => {
        newDocs.push({
          name: file.name,
          type: file.type,
          size: file.size,
          data: reader.result,
          uploaded_at: new Date().toISOString()
        });
        if (newDocs.length === files.length) {
          setFormFunc(prev => ({
            ...prev,
            [formKey]: [...(prev[formKey] || []), ...newDocs]
          }));
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const removeDocument = (setFormFunc, formKey, index) => {
    setFormFunc(prev => ({
      ...prev,
      [formKey]: prev[formKey].filter((_, i) => i !== index)
    }));
  };

  // CRUD Operations
  const handleCreateSubcontractor = async () => {
    if (!formData.company_name.trim()) {
      toast.error('Şirket ismi gerekli');
      return;
    }
    try {
      await axios.post(`${API}/branch/subcontractors`, formData, { headers: getAuthHeaders() });
      toast.success('Taşeron eklendi');
      setCreateModalOpen(false);
      resetForm();
      loadSubcontractors();
    } catch (error) {
      toast.error('Taşeron eklenemedi');
    }
  };

  const handleEditSubcontractor = async () => {
    if (!formData.company_name.trim()) {
      toast.error('Şirket ismi gerekli');
      return;
    }
    try {
      await axios.put(`${API}/branch/subcontractors/${selectedSubcontractor.id}`, formData, { headers: getAuthHeaders() });
      toast.success('Taşeron güncellendi');
      setEditModalOpen(false);
      resetForm();
      loadSubcontractors();
    } catch (error) {
      toast.error('Taşeron güncellenemedi');
    }
  };

  const handleFinishSubcontractorTask = async (id) => {
    if (!window.confirm("Bu taşeronun görevini bitirdiğini İK'ya bildirmek istiyor musunuz?")) return;
    try {
      await axios.post(`${API}/subcontractors/${id}/finish-task`, {}, { headers: getAuthHeaders() });
      toast.success("Görev bitirme bildirimi İK'ya gönderildi");
      loadSubcontractors();
    } catch (error) {
      toast.error('Bildirim gönderilemedi');
    }
  };

  // Hakediş CRUD
  const handleCreateHakedis = async () => {
    if (!hakedisForm.title.trim()) {
      toast.error('Başlık gerekli');
      return;
    }
    if (!hakedisForm.amount) {
      toast.error('Hakediş miktarı gerekli');
      return;
    }
    try {
      await axios.post(`${API}/branch/subcontractors/${selectedSubcontractor.id}/hakedis`, hakedisForm, { headers: getAuthHeaders() });
      toast.success('Hakediş eklendi');
      setHakedisModalOpen(false);
      setHakedisForm({ hakedis_date: new Date().toISOString().split('T')[0], title: '', amount: '', description: '', documents: [] });
      loadTabData('hakedis');
    } catch (error) {
      toast.error('Hakediş eklenemedi');
    }
  };

  const handleDeleteHakedis = async (id) => {
    try {
      await axios.delete(`${API}/branch/subcontractors/${selectedSubcontractor.id}/hakedis/${id}`, { headers: getAuthHeaders() });
      toast.success('Hakediş silindi');
      loadTabData('hakedis');
    } catch (error) {
      toast.error('Hakediş silinemedi');
    }
  };

  const handleApproveHakedis = async (id, approvalType) => {
    try {
      await axios.post(`${API}/branch/subcontractors/${selectedSubcontractor.id}/hakedis/${id}/approve`, 
        { approval_type: approvalType }, 
        { headers: getAuthHeaders() }
      );
      toast.success('Hakediş onaylandı');
      loadTabData('hakedis');
    } catch (error) {
      toast.error('Hakediş onaylanamadı');
    }
  };

  // Sözleşme CRUD
  const handleCreateSozlesme = async () => {
    if (!sozlesmeForm.work_type.trim()) {
      toast.error('İş türü gerekli');
      return;
    }
    try {
      await axios.post(`${API}/branch/subcontractors/${selectedSubcontractor.id}/sozlesme`, sozlesmeForm, { headers: getAuthHeaders() });
      toast.success('Sözleşme eklendi');
      setSozlesmeModalOpen(false);
      setSozlesmeForm({ contract_date: new Date().toISOString().split('T')[0], work_type: '', start_date: '', end_date: '', documents: [] });
      loadTabData('sozlesme');
    } catch (error) {
      toast.error('Sözleşme eklenemedi');
    }
  };

  const handleDeleteSozlesme = async (id) => {
    try {
      await axios.delete(`${API}/branch/subcontractors/${selectedSubcontractor.id}/sozlesme/${id}`, { headers: getAuthHeaders() });
      toast.success('Sözleşme silindi');
      loadTabData('sozlesme');
    } catch (error) {
      toast.error('Sözleşme silinemedi');
    }
  };

  // İş Programı CRUD
  const handleCreateIsProgrami = async () => {
    if (!isProgramiForm.subject.trim()) {
      toast.error('Konu gerekli');
      return;
    }
    try {
      await axios.post(`${API}/branch/subcontractors/${selectedSubcontractor.id}/is-programi`, isProgramiForm, { headers: getAuthHeaders() });
      toast.success('İş programı eklendi');
      setIsProgramiModalOpen(false);
      setIsProgramiForm({ subject: '', description: '', start_date: '', end_date: '', documents: [] });
      loadTabData('is-programi');
    } catch (error) {
      toast.error('İş programı eklenemedi');
    }
  };

  const handleDeleteIsProgrami = async (id) => {
    try {
      await axios.delete(`${API}/branch/subcontractors/${selectedSubcontractor.id}/is-programi/${id}`, { headers: getAuthHeaders() });
      toast.success('İş programı silindi');
      loadTabData('is-programi');
    } catch (error) {
      toast.error('İş programı silinemedi');
    }
  };

  // Tutanak CRUD
  const handleCreateTutanak = async () => {
    if (!tutanakForm.title.trim()) {
      toast.error('Tutanak başlığı gerekli');
      return;
    }
    try {
      await axios.post(`${API}/branch/subcontractors/${selectedSubcontractor.id}/tutanaklar`, tutanakForm, { headers: getAuthHeaders() });
      toast.success('Tutanak eklendi');
      setTutanakModalOpen(false);
      setTutanakForm({ report_date: new Date().toISOString().split('T')[0], title: '', content: '', description: '', documents: [] });
      loadTabData('tutanaklar');
    } catch (error) {
      toast.error('Tutanak eklenemedi');
    }
  };

  const handleDeleteTutanak = async (id) => {
    try {
      await axios.delete(`${API}/branch/subcontractors/${selectedSubcontractor.id}/tutanaklar/${id}`, { headers: getAuthHeaders() });
      toast.success('Tutanak silindi');
      loadTabData('tutanaklar');
    } catch (error) {
      toast.error('Tutanak silinemedi');
    }
  };

  const handleApproveTutanak = async (id) => {
    try {
      await axios.post(`${API}/branch/subcontractors/${selectedSubcontractor.id}/tutanaklar/${id}/approve`, {}, { headers: getAuthHeaders() });
      toast.success('Tutanak onaylandı');
      loadTabData('tutanaklar');
    } catch (error) {
      toast.error('Tutanak onaylanamadı');
    }
  };

  // İş Bilgisi CRUD
  const handleCreateIsBilgisi = async () => {
    if (!isBilgisiForm.title.trim()) {
      toast.error('İş bilgisi başlığı gerekli');
      return;
    }
    try {
      await axios.post(`${API}/branch/subcontractors/${selectedSubcontractor.id}/is-bilgisi`, isBilgisiForm, { headers: getAuthHeaders() });
      toast.success('İş bilgisi eklendi');
      setIsBilgisiModalOpen(false);
      setIsBilgisiForm({ report_date: new Date().toISOString().split('T')[0], title: '', content: '', description: '', documents: [] });
      loadTabData('is-bilgisi');
    } catch (error) {
      toast.error('İş bilgisi eklenemedi');
    }
  };

  const handleDeleteIsBilgisi = async (id) => {
    try {
      await axios.delete(`${API}/branch/subcontractors/${selectedSubcontractor.id}/is-bilgisi/${id}`, { headers: getAuthHeaders() });
      toast.success('İş bilgisi silindi');
      loadTabData('is-bilgisi');
    } catch (error) {
      toast.error('İş bilgisi silinemedi');
    }
  };

  // Malzeme Kullanımı CRUD
  const handleCreateMalzeme = async () => {
    if (!malzemeForm.material_name.trim()) {
      toast.error('Malzeme adı gerekli');
      return;
    }
    try {
      await axios.post(`${API}/branch/subcontractors/${selectedSubcontractor.id}/malzeme-kullanimi`, malzemeForm, { headers: getAuthHeaders() });
      toast.success('Malzeme kullanımı eklendi');
      setMalzemeModalOpen(false);
      setMalzemeForm({ usage_date: new Date().toISOString().split('T')[0], material_name: '', quantity: '', unit: 'adet', description: '', documents: [] });
      loadTabData('malzeme-kullanimi');
    } catch (error) {
      toast.error('Malzeme kullanımı eklenemedi');
    }
  };

  const handleDeleteMalzeme = async (id) => {
    try {
      await axios.delete(`${API}/branch/subcontractors/${selectedSubcontractor.id}/malzeme-kullanimi/${id}`, { headers: getAuthHeaders() });
      toast.success('Malzeme kullanımı silindi');
      loadTabData('malzeme-kullanimi');
    } catch (error) {
      toast.error('Malzeme kullanımı silinemedi');
    }
  };

  // Hakediş İletme (Forward)
  const openForwardModal = (item) => {
    setForwardingItem(item);
    setForwardTarget('muhasebe');
    setForwardNote('');
    setForwardModalOpen(true);
  };

  const handleForwardHakedis = async () => {
    if (!forwardingItem) return;
    setIsForwarding(true);
    try {
      await axios.post(
        `${API}/branch/subcontractors/${selectedSubcontractor.id}/hakedis/${forwardingItem.id}/forward`,
        { target: forwardTarget, note: forwardNote },
        { headers: getAuthHeaders() }
      );
      const targetName = forwardTarget === 'muhasebe' ? 'Muhasebe' : 'Yönetim';
      toast.success(`Hakediş ${targetName}'e iletildi`);
      setForwardModalOpen(false);
      setForwardingItem(null);
      loadTabData('hakedis');
    } catch (error) {
      toast.error('Hakediş iletilemedi');
    }
    setIsForwarding(false);
  };

  const openEditModal = (subcontractor) => {
    setSelectedSubcontractor(subcontractor);
    setFormData({
      company_name: subcontractor.company_name || subcontractor.name || '',
      company_duties: subcontractor.company_duties || '',
      contacts: subcontractor.contacts?.length > 0 
        ? subcontractor.contacts 
        : [{ name: '', title: '', phone: '', email: '' }],
      start_date: subcontractor.start_date || '',
      end_date: subcontractor.end_date || '',
      provided_service: subcontractor.provided_service || '',
      custom_fields: subcontractor.custom_fields || [],
      visible_to_users: subcontractor.visible_to_users || [],
      contract_viewers: subcontractor.contract_viewers || []
    });
    setEditModalOpen(true);
  };

  // delete modal logic removed

  const openDetailView = (subcontractor) => {
    setSelectedSubcontractor(subcontractor);
    setDetailView(true);
    setActiveTab('hakedis');
  };

  const addContact = () => {
    setFormData(prev => ({
      ...prev,
      contacts: [...prev.contacts, { name: '', title: '', phone: '', email: '' }]
    }));
  };

  const removeContact = (index) => {
    if (formData.contacts.length > 1) {
      setFormData(prev => ({
        ...prev,
        contacts: prev.contacts.filter((_, i) => i !== index)
      }));
    }
  };

  const updateContact = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      contacts: prev.contacts.map((contact, i) => 
        i === index ? { ...contact, [field]: value } : contact
      )
    }));
  };

  // Kullanıcı görünürlük toggle fonksiyonları
  const toggleUserVisibility = (userId) => {
    setFormData(prev => ({
      ...prev,
      visible_to_users: prev.visible_to_users.includes(userId)
        ? prev.visible_to_users.filter(id => id !== userId)
        : [...prev.visible_to_users, userId]
    }));
  };

  const toggleContractViewer = (userId) => {
    setFormData(prev => ({
      ...prev,
      contract_viewers: prev.contract_viewers.includes(userId)
        ? prev.contract_viewers.filter(id => id !== userId)
        : [...prev.contract_viewers, userId]
    }));
  };

  const selectAllVisibleUsers = () => {
    setFormData(prev => ({
      ...prev,
      visible_to_users: workPanelUsers.map(u => u.id)
    }));
  };

  const clearVisibleUsers = () => {
    setFormData(prev => ({
      ...prev,
      visible_to_users: []
    }));
  };

  const selectAllContractViewers = () => {
    setFormData(prev => ({
      ...prev,
      contract_viewers: workPanelUsers.map(u => u.id)
    }));
  };

  const clearContractViewers = () => {
    setFormData(prev => ({
      ...prev,
      contract_viewers: []
    }));
  };

  const openItemDetail = (item) => {
    setSelectedItem(item);
    setDetailModalOpen(true);
  };

  const downloadDocument = (doc) => {
    const link = document.createElement('a');
    link.href = doc.data;
    link.download = doc.name;
    link.click();
  };

  // Detay görünümü
  if (detailView && selectedSubcontractor) {
    return (
      <div className="space-y-6" data-testid="subcontractor-detail">
        {/* Header */}
        <div className="flex items-center gap-4">
          <Button variant="outline" onClick={() => setDetailView(false)} className="gap-2" data-testid="back-to-list-btn">
            <ChevronLeft className="h-4 w-4" />
            Geri
          </Button>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{selectedSubcontractor.name || selectedSubcontractor.company_name || 'İsimsiz Taşeron'}</h1>
            <p className="text-gray-500">{selectedSubcontractor.company_duties}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <Card>
            <CardHeader className="pb-2">
              <CardTitle className="text-lg flex items-center gap-2"><Briefcase className="h-5 w-5 text-amber-600" /> Çalışma Bilgileri</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                <div className="flex justify-between py-1 border-b">
                  <span className="text-gray-500">İşe Başlama:</span>
                  <span className="font-medium">{selectedSubcontractor.start_date ? new Date(selectedSubcontractor.start_date).toLocaleDateString('tr-TR') : '-'}</span>
                </div>
                <div className="flex justify-between py-1 border-b">
                  <span className="text-gray-500">Bitiş Tarihi:</span>
                  <span className="font-medium">{selectedSubcontractor.end_date ? new Date(selectedSubcontractor.end_date).toLocaleDateString('tr-TR') : '-'}</span>
                </div>
                <div className="flex justify-between py-1 border-b">
                  <span className="text-gray-500">Verdiği Hizmet:</span>
                  <span className="font-medium">{selectedSubcontractor.provided_service || selectedSubcontractor.company_duties || '-'}</span>
                </div>
              </div>
            </CardContent>
          </Card>

          {selectedSubcontractor.custom_fields && selectedSubcontractor.custom_fields.length > 0 && (
            <Card>
              <CardHeader className="pb-2">
                <CardTitle className="text-lg flex items-center gap-2"><FileText className="h-5 w-5 text-amber-600" /> Ek Bilgiler</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-2">
                  {selectedSubcontractor.custom_fields.map((field, idx) => (
                    <div key={idx} className="flex justify-between py-1 border-b">
                      <span className="text-gray-500">{field.key}:</span>
                      <span className="font-medium">{field.value}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          )}
        </div>

        {/* Yetkili Bilgileri */}
        {selectedSubcontractor.contacts?.length > 0 && (
          <Card>
            <CardHeader className="pb-2">
              <CardTitle className="text-lg">Yetkili Kişiler</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {selectedSubcontractor.contacts.map((contact, idx) => (
                  <div key={idx} className="bg-gray-50 p-3 rounded-lg">
                    <div className="flex items-center gap-2 mb-2">
                      <User className="h-4 w-4 text-amber-600" />
                      <span className="font-medium">{contact.name || '-'}</span>
                    </div>
                    {contact.title && <div className="flex items-center gap-2 text-sm text-gray-600"><Briefcase className="h-3 w-3" />{contact.title}</div>}
                    {contact.phone && <div className="flex items-center gap-2 text-sm text-gray-600"><Phone className="h-3 w-3" />{contact.phone}</div>}
                    {contact.email && <div className="flex items-center gap-2 text-sm text-gray-600"><Mail className="h-3 w-3" />{contact.email}</div>}
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        )}

        {/* Tabs */}
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <div className="overflow-x-auto">
            <TabsList className="inline-flex w-auto min-w-full">
              <TabsTrigger value="hakedis" className="gap-1 relative px-3">
                <Receipt className="h-4 w-4" /><span className="hidden md:inline">Hakediş</span>
                {getTabNewCount(selectedSubcontractor.id, 'hakedis') > 0 && (
                  <Badge className="absolute -top-1 -right-1 h-4 w-4 p-0 flex items-center justify-center text-[10px] bg-red-500 text-white">
                    {getTabNewCount(selectedSubcontractor.id, 'hakedis')}
                  </Badge>
                )}
              </TabsTrigger>
              <TabsTrigger value="sozlesme" className="gap-1 relative px-3">
                <FileSignature className="h-4 w-4" /><span className="hidden md:inline">Sözleşme</span>
                {getTabNewCount(selectedSubcontractor.id, 'sozlesme') > 0 && (
                  <Badge className="absolute -top-1 -right-1 h-4 w-4 p-0 flex items-center justify-center text-[10px] bg-red-500 text-white">
                    {getTabNewCount(selectedSubcontractor.id, 'sozlesme')}
                  </Badge>
                )}
              </TabsTrigger>
              <TabsTrigger value="personel" className="gap-1 relative px-3">
                <Users className="h-4 w-4" /><span className="hidden md:inline">Personel</span>
                {personelData.total_count > 0 && (
                  <Badge className="absolute -top-1 -right-1 h-4 w-4 p-0 flex items-center justify-center text-[10px] bg-blue-500 text-white">
                    {personelData.total_count}
                  </Badge>
                )}
              </TabsTrigger>
              <TabsTrigger value="is-programi" className="gap-1 relative px-3">
                <Calendar className="h-4 w-4" /><span className="hidden md:inline">İş Programı</span>
                {getTabNewCount(selectedSubcontractor.id, 'is-programi') > 0 && (
                  <Badge className="absolute -top-1 -right-1 h-4 w-4 p-0 flex items-center justify-center text-[10px] bg-red-500 text-white">
                    {getTabNewCount(selectedSubcontractor.id, 'is-programi')}
                  </Badge>
                )}
              </TabsTrigger>
              <TabsTrigger value="tutanaklar" className="gap-1 relative px-3">
                <ClipboardList className="h-4 w-4" /><span className="hidden md:inline">Tutanaklar</span>
                {getTabNewCount(selectedSubcontractor.id, 'tutanaklar') > 0 && (
                  <Badge className="absolute -top-1 -right-1 h-4 w-4 p-0 flex items-center justify-center text-[10px] bg-red-500 text-white">
                    {getTabNewCount(selectedSubcontractor.id, 'tutanaklar')}
                  </Badge>
                )}
              </TabsTrigger>
              <TabsTrigger value="is-bilgisi" className="gap-1 relative px-3">
                <FileText className="h-4 w-4" /><span className="hidden md:inline">İş Bilgisi</span>
                {getTabNewCount(selectedSubcontractor.id, 'is-bilgisi') > 0 && (
                  <Badge className="absolute -top-1 -right-1 h-4 w-4 p-0 flex items-center justify-center text-[10px] bg-red-500 text-white">
                    {getTabNewCount(selectedSubcontractor.id, 'is-bilgisi')}
                  </Badge>
                )}
              </TabsTrigger>
              <TabsTrigger value="malzeme-kullanimi" className="gap-1 relative px-3">
                <Package className="h-4 w-4" /><span className="hidden md:inline">Malzeme</span>
                {getTabNewCount(selectedSubcontractor.id, 'malzeme-kullanimi') > 0 && (
                  <Badge className="absolute -top-1 -right-1 h-4 w-4 p-0 flex items-center justify-center text-[10px] bg-red-500 text-white">
                    {getTabNewCount(selectedSubcontractor.id, 'malzeme-kullanimi')}
                  </Badge>
                )}
              </TabsTrigger>
              <TabsTrigger value="tasinan-raporlar" className="gap-1 relative px-3" data-testid="tasinan-raporlar-tab">
                <FileBarChart className="h-4 w-4" /><span className="hidden md:inline">Raporlar</span>
                {getTabNewCount(selectedSubcontractor.id, 'tasinan-raporlar') > 0 && (
                  <Badge className="absolute -top-1 -right-1 h-4 w-4 p-0 flex items-center justify-center text-[10px] bg-red-500 text-white">
                    {getTabNewCount(selectedSubcontractor.id, 'tasinan-raporlar')}
                  </Badge>
                )}
              </TabsTrigger>
            </TabsList>
          </div>

          {/* Hakediş Tab */}
          <TabsContent value="hakedis" className="mt-4">
            <Card>
              <CardHeader className="flex flex-row items-center justify-between">
                <CardTitle className="flex items-center gap-2"><Receipt className="h-5 w-5 text-amber-600" />Hakediş</CardTitle>
                <Button onClick={() => setHakedisModalOpen(true)} className="bg-amber-600 hover:bg-amber-700 gap-2">
                  <Plus className="h-4 w-4" />HAKEDİŞ EKLE
                </Button>
              </CardHeader>
              <CardContent>
                {tabLoading ? (
                  <div className="flex justify-center py-8"><Loader2 className="h-8 w-8 animate-spin text-amber-600" /></div>
                ) : hakedisData.length === 0 ? (
                  <div className="text-center py-8 text-gray-500"><Receipt className="h-12 w-12 mx-auto mb-2 opacity-50" /><p>Henüz hakediş kaydı yok</p></div>
                ) : (
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Tarih</TableHead>
                        <TableHead>Başlık</TableHead>
                        <TableHead>Miktar (TL)</TableHead>
                        <TableHead>Yapan Kişi</TableHead>
                        <TableHead>Belgeler</TableHead>
                        <TableHead className="text-center">Şube Yöneticisi Onay</TableHead>
                        <TableHead className="text-center">Yönetim Onay</TableHead>
                        <TableHead>İşlemler</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {hakedisData.map(item => (
                        <TableRow key={item.id} className={item.is_new ? 'bg-red-50 ring-2 ring-red-400 ring-inset' : ''}>
                          <TableCell>
                            <div className="flex items-center gap-2">
                              {item.hakedis_date}
                              {item.is_new && <Badge className="bg-red-500 text-white animate-pulse text-xs">YENİ</Badge>}
                            </div>
                          </TableCell>
                          <TableCell className="font-medium">{item.title}</TableCell>
                          <TableCell className="font-semibold text-green-600">
                            {item.amount ? `${Number(item.amount).toLocaleString('tr-TR')} TL` : '-'}
                          </TableCell>
                          <TableCell>{item.created_by_name || '-'}</TableCell>
                          <TableCell><Badge variant="outline">{item.documents?.length || 0} belge</Badge></TableCell>
                          <TableCell className="text-center">
                            {item.branch_manager_approved ? (
                              <Badge className="bg-green-100 text-green-700 border-green-200">
                                ✓ Onaylandı
                              </Badge>
                            ) : (
                              <Button 
                                size="sm" 
                                variant="outline" 
                                className="text-green-600 border-green-300 hover:bg-green-50"
                                onClick={() => handleApproveHakedis(item.id, 'branch_manager')}
                              >
                                <Plus className="h-4 w-4" />
                              </Button>
                            )}
                          </TableCell>
                          <TableCell className="text-center">
                            {/* Yönetim Onayı sadece Yönetim Kurulu Paneli'nden yapılabilir */}
                            {item.management_approved ? (
                              <Badge className="bg-blue-100 text-blue-700 border-blue-200">
                                ✓ Onaylandı
                              </Badge>
                            ) : (
                              <Badge variant="outline" className="text-gray-400">Bekliyor</Badge>
                            )}
                          </TableCell>
                          <TableCell>
                            <div className="flex gap-2">
                              <Button size="sm" variant="outline" onClick={() => openItemDetail(item)}><Eye className="h-4 w-4" /></Button>
                              {!item.forwarded && (
                                <Button size="sm" variant="outline" className="text-blue-600" onClick={() => openForwardModal(item)}>
                                  <Send className="h-4 w-4" />
                                </Button>
                              )}
                              <Button size="sm" variant="outline" className="text-red-600" onClick={() => handleDeleteHakedis(item.id)}><Trash2 className="h-4 w-4" /></Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </CardContent>
            </Card>
          </TabsContent>

          {/* Sözleşme Tab */}
          <TabsContent value="sozlesme" className="mt-4">
            <Card>
              <CardHeader className="flex flex-row items-center justify-between">
                <CardTitle className="flex items-center gap-2"><FileSignature className="h-5 w-5 text-amber-600" />Sözleşme</CardTitle>
                <Button onClick={() => setSozlesmeModalOpen(true)} className="bg-amber-600 hover:bg-amber-700 gap-2">
                  <Plus className="h-4 w-4" />SÖZLEŞME EKLE
                </Button>
              </CardHeader>
              <CardContent>
                {tabLoading ? (
                  <div className="flex justify-center py-8"><Loader2 className="h-8 w-8 animate-spin text-amber-600" /></div>
                ) : sozlesmeData.length === 0 ? (
                  <div className="text-center py-8 text-gray-500"><FileSignature className="h-12 w-12 mx-auto mb-2 opacity-50" /><p>Henüz sözleşme yok</p></div>
                ) : (
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Tarih</TableHead>
                        <TableHead>İş Türü</TableHead>
                        <TableHead>Başlangıç</TableHead>
                        <TableHead>Bitiş</TableHead>
                        <TableHead>Belgeler</TableHead>
                        <TableHead>İşlemler</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {sozlesmeData.map(item => (
                        <TableRow key={item.id} className={item.is_new ? 'bg-red-50 ring-2 ring-red-400 ring-inset' : ''}>
                          <TableCell>
                            <div className="flex items-center gap-2">
                              {item.contract_date}
                              {item.is_new && <Badge className="bg-red-500 text-white animate-pulse text-xs">YENİ</Badge>}
                            </div>
                          </TableCell>
                          <TableCell className="font-medium">{item.work_type}</TableCell>
                          <TableCell>{item.start_date}</TableCell>
                          <TableCell>{item.end_date}</TableCell>
                          <TableCell><Badge variant="outline">{item.documents?.length || 0} belge</Badge></TableCell>
                          <TableCell>
                            <div className="flex gap-2">
                              <Button size="sm" variant="outline" onClick={() => openItemDetail(item)}><Eye className="h-4 w-4" /></Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </CardContent>
            </Card>
          </TabsContent>

          {/* Personel Tab */}
          <TabsContent value="personel" className="mt-4">
            <Card>
              <CardHeader className="flex flex-row items-center justify-between">
                <CardTitle className="flex items-center gap-2">
                  <Users className="h-5 w-5 text-blue-600" />
                  Personel Listesi
                  <Badge variant="outline" className="ml-2">{personelData.total_count} kişi</Badge>
                </CardTitle>
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-2">
                    <Button 
                      variant="outline" 
                      size="sm"
                      onClick={() => {
                        const prev = new Date(personelDate);
                        prev.setDate(prev.getDate() - 1);
                        handlePersonelDateChange(prev.toISOString().split('T')[0]);
                      }}
                    >
                      <ChevronLeft className="h-4 w-4" />
                    </Button>
                    <Input
                      type="date"
                      value={personelDate}
                      onChange={(e) => handlePersonelDateChange(e.target.value)}
                      className="w-40"
                    />
                    <Button 
                      variant="outline" 
                      size="sm"
                      onClick={() => {
                        const next = new Date(personelDate);
                        next.setDate(next.getDate() + 1);
                        handlePersonelDateChange(next.toISOString().split('T')[0]);
                      }}
                    >
                      <ChevronRight className="h-4 w-4" />
                    </Button>
                  </div>
                  <div className="flex gap-2">
                    <Badge className="bg-amber-100 text-amber-700">
                      <Sun className="h-3 w-3 mr-1" />
                      Sabah: {personelData.sabah_count || 0}
                    </Badge>
                    <Badge className="bg-orange-100 text-orange-700">
                      <CloudSun className="h-3 w-3 mr-1" />
                      Öğle: {personelData.ogle_count || 0}
                    </Badge>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                {tabLoading ? (
                  <div className="flex justify-center py-8"><Loader2 className="h-8 w-8 animate-spin text-blue-600" /></div>
                ) : personelData.employees?.length === 0 ? (
                  <div className="text-center py-8 text-gray-500">
                    <Users className="h-12 w-12 mx-auto mb-2 opacity-50" />
                    <p>Bu taşerona ait personel kaydı bulunmuyor</p>
                    <p className="text-sm mt-1">Personeller İK Panelinden bu taşerona atanabilir</p>
                  </div>
                ) : (
                  <div className="max-h-[500px] overflow-y-auto">
                    <Table>
                      <TableHeader>
                        <TableRow>
                          <TableHead>Ad Soyad</TableHead>
                          <TableHead>Pozisyon</TableHead>
                          <TableHead>Meslek</TableHead>
                          <TableHead>Telefon</TableHead>
                          <TableHead className="text-center">
                            <div className="flex items-center justify-center gap-1">
                              <Sun className="h-4 w-4 text-amber-500" />
                              SABAH MESAİ
                            </div>
                          </TableHead>
                          <TableHead className="text-center">
                            <div className="flex items-center justify-center gap-1">
                              <CloudSun className="h-4 w-4 text-orange-500" />
                              ÖĞLE MESAİ
                            </div>
                          </TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {personelData.employees?.map(emp => (
                          <TableRow key={emp.id}>
                            <TableCell className="font-medium">{emp.name}</TableCell>
                            <TableCell>{emp.position_name || emp.gorev || '-'}</TableCell>
                            <TableCell>{emp.profession || emp.meslek || '-'}</TableCell>
                            <TableCell>{emp.phone || '-'}</TableCell>
                            <TableCell className="text-center">
                              {emp.attendance?.morning_time ? (
                                <Badge className="bg-green-100 text-green-700 font-mono">
                                  {emp.attendance.morning_time}
                                </Badge>
                              ) : (
                                <Badge variant="outline" className="text-gray-400">
                                  Bildirim Yok
                                </Badge>
                              )}
                            </TableCell>
                            <TableCell className="text-center">
                              {emp.attendance?.afternoon_time ? (
                                <Badge className="bg-blue-100 text-blue-700 font-mono">
                                  {emp.attendance.afternoon_time}
                                </Badge>
                              ) : (
                                <Badge variant="outline" className="text-gray-400">
                                  Bildirim Yok
                                </Badge>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                )}
              </CardContent>
            </Card>
          </TabsContent>

          {/* İş Programı Tab */}
          <TabsContent value="is-programi" className="mt-4">
            <Card>
              <CardHeader className="flex flex-row items-center justify-between">
                <CardTitle className="flex items-center gap-2"><Calendar className="h-5 w-5 text-amber-600" />İş Programı</CardTitle>
                <Button onClick={() => setIsProgramiModalOpen(true)} className="bg-amber-600 hover:bg-amber-700 gap-2">
                  <Plus className="h-4 w-4" />İŞ PROGRAMI EKLE
                </Button>
              </CardHeader>
              <CardContent>
                {tabLoading ? (
                  <div className="flex justify-center py-8"><Loader2 className="h-8 w-8 animate-spin text-amber-600" /></div>
                ) : isProgramiData.length === 0 ? (
                  <div className="text-center py-8 text-gray-500"><Calendar className="h-12 w-12 mx-auto mb-2 opacity-50" /><p>Henüz iş programı yok</p></div>
                ) : (
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Konu</TableHead>
                        <TableHead>Açıklama</TableHead>
                        <TableHead>Başlangıç</TableHead>
                        <TableHead>Bitiş</TableHead>
                        <TableHead>Belgeler</TableHead>
                        <TableHead>İşlemler</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {isProgramiData.map(item => (
                        <TableRow key={item.id} className={item.is_new ? 'bg-red-50 ring-2 ring-red-400 ring-inset' : ''}>
                          <TableCell className="font-medium">
                            <div className="flex items-center gap-2">
                              {item.subject}
                              {item.is_new && <Badge className="bg-red-500 text-white animate-pulse text-xs">YENİ</Badge>}
                            </div>
                          </TableCell>
                          <TableCell className="max-w-xs truncate">{item.description}</TableCell>
                          <TableCell>{item.start_date}</TableCell>
                          <TableCell>{item.end_date}</TableCell>
                          <TableCell><Badge variant="outline">{item.documents?.length || 0} belge</Badge></TableCell>
                          <TableCell>
                            <div className="flex gap-2">
                              <Button size="sm" variant="outline" onClick={() => openItemDetail(item)}><Eye className="h-4 w-4" /></Button>
                              <Button size="sm" variant="outline" className="text-red-600" onClick={() => handleDeleteIsProgrami(item.id)}><Trash2 className="h-4 w-4" /></Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </CardContent>
            </Card>
          </TabsContent>

          {/* Tutanaklar Tab */}
          <TabsContent value="tutanaklar" className="mt-4">
            <Card>
              <CardHeader className="flex flex-row items-center justify-between">
                <CardTitle className="flex items-center gap-2"><ClipboardList className="h-5 w-5 text-amber-600" />Tutanaklar</CardTitle>
                <Button onClick={() => setTutanakModalOpen(true)} className="bg-amber-600 hover:bg-amber-700 gap-2">
                  <Plus className="h-4 w-4" />TUTANAK EKLE
                </Button>
              </CardHeader>
              <CardContent>
                {tabLoading ? (
                  <div className="flex justify-center py-8"><Loader2 className="h-8 w-8 animate-spin text-amber-600" /></div>
                ) : tutanakData.length === 0 ? (
                  <div className="text-center py-8 text-gray-500"><ClipboardList className="h-12 w-12 mx-auto mb-2 opacity-50" /><p>Henüz tutanak yok</p></div>
                ) : (
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Tarih</TableHead>
                        <TableHead>Başlık</TableHead>
                        <TableHead>Açıklama</TableHead>
                        <TableHead>Belgeler</TableHead>
                        <TableHead className="text-center">Şube Yöneticisi Onay</TableHead>
                        <TableHead>İşlemler</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {tutanakData.map(item => (
                        <TableRow key={item.id} className={item.is_new ? 'bg-red-50 ring-2 ring-red-400 ring-inset' : ''}>
                          <TableCell>
                            <div className="flex items-center gap-2">
                              {item.report_date || new Date(item.created_at).toLocaleDateString('tr-TR')}
                              {item.is_new && <Badge className="bg-red-500 text-white animate-pulse text-xs">YENİ</Badge>}
                            </div>
                          </TableCell>
                          <TableCell className="font-medium max-w-xs truncate">{item.title || item.content}</TableCell>
                          <TableCell className="max-w-xs truncate">{item.description}</TableCell>
                          <TableCell><Badge variant="outline">{item.documents?.length || 0} belge</Badge></TableCell>
                          <TableCell className="text-center">
                            {item.branch_manager_approved ? (
                              <Badge className="bg-green-100 text-green-700 border-green-200">
                                ✓ Onaylandı
                              </Badge>
                            ) : (
                              <Button 
                                size="sm" 
                                variant="outline" 
                                className="text-green-600 border-green-300 hover:bg-green-50"
                                onClick={() => handleApproveTutanak(item.id)}
                              >
                                <Plus className="h-4 w-4" />
                              </Button>
                            )}
                          </TableCell>
                          <TableCell>
                            <div className="flex gap-2">
                              <Button size="sm" variant="outline" onClick={() => openItemDetail(item)}><Eye className="h-4 w-4" /></Button>
                              <Button size="sm" variant="outline" className="text-red-600" onClick={() => handleDeleteTutanak(item.id)}><Trash2 className="h-4 w-4" /></Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </CardContent>
            </Card>
          </TabsContent>

          {/* İş Bilgisi Tab */}
          <TabsContent value="is-bilgisi" className="mt-4">
            <Card>
              <CardHeader className="flex flex-row items-center justify-between">
                <CardTitle className="flex items-center gap-2"><FileText className="h-5 w-5 text-amber-600" />İş Bilgisi</CardTitle>
                <Button onClick={() => setIsBilgisiModalOpen(true)} className="bg-amber-600 hover:bg-amber-700 gap-2">
                  <Plus className="h-4 w-4" />İŞ BİLGİSİ EKLE
                </Button>
              </CardHeader>
              <CardContent>
                {tabLoading ? (
                  <div className="flex justify-center py-8"><Loader2 className="h-8 w-8 animate-spin text-amber-600" /></div>
                ) : isBilgisiData.length === 0 ? (
                  <div className="text-center py-8 text-gray-500"><FileText className="h-12 w-12 mx-auto mb-2 opacity-50" /><p>Henüz iş bilgisi yok</p></div>
                ) : (
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Tarih</TableHead>
                        <TableHead>Başlık</TableHead>
                        <TableHead>Açıklama</TableHead>
                        <TableHead>Belgeler</TableHead>
                        <TableHead>İşlemler</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {isBilgisiData.map(item => (
                        <TableRow key={item.id} className={item.is_new ? 'bg-red-50 ring-2 ring-red-400 ring-inset' : ''}>
                          <TableCell>
                            <div className="flex items-center gap-2">
                              {item.report_date || new Date(item.created_at).toLocaleDateString('tr-TR')}
                              {item.is_new && <Badge className="bg-red-500 text-white animate-pulse text-xs">YENİ</Badge>}
                            </div>
                          </TableCell>
                          <TableCell className="font-medium max-w-xs truncate">{item.title || item.content}</TableCell>
                          <TableCell className="max-w-xs truncate">{item.description}</TableCell>
                          <TableCell><Badge variant="outline">{item.documents?.length || 0} belge</Badge></TableCell>
                          <TableCell>
                            <div className="flex gap-2">
                              <Button size="sm" variant="outline" onClick={() => openItemDetail(item)}><Eye className="h-4 w-4" /></Button>
                              <Button size="sm" variant="outline" className="text-red-600" onClick={() => handleDeleteIsBilgisi(item.id)}><Trash2 className="h-4 w-4" /></Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </CardContent>
            </Card>
          </TabsContent>

          {/* Malzeme Kullanımı Tab */}
          <TabsContent value="malzeme-kullanimi" className="mt-4">
            {/* Depodan Verilen Malzemeler */}
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Package className="h-5 w-5 text-blue-600" />
                  Taşerona Verilen Malzemeler
                  <Badge variant="outline" className="ml-2">{depoMalzemeleri.length}</Badge>
                </CardTitle>
              </CardHeader>
              <CardContent>
                {tabLoading ? (
                  <div className="flex justify-center py-8"><Loader2 className="h-8 w-8 animate-spin text-blue-600" /></div>
                ) : depoMalzemeleri.length === 0 ? (
                  <div className="text-center py-6 text-gray-500">
                    <Package className="h-10 w-10 mx-auto mb-2 opacity-50" />
                    <p className="text-sm">Bu taşerona depodan verilmiş malzeme yok</p>
                  </div>
                ) : (
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Tarih / Saat</TableHead>
                        <TableHead>Ürünler</TableHead>
                        <TableHead>Miktar</TableHead>
                        <TableHead>Teslim Alan</TableHead>
                        <TableHead>Teslim Tarihi</TableHead>
                        <TableHead>İşlem Yapan</TableHead>
                        <TableHead>Açıklama</TableHead>
                        <TableHead>Talep Belgesi</TableHead>
                        <TableHead>Teslim Belgesi</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {depoMalzemeleri.map(cikis => (
                        <TableRow key={cikis.id} className="hover:bg-blue-50">
                          <TableCell>
                            <div className="flex flex-col">
                              <span className="font-medium">{new Date(cikis.created_at).toLocaleDateString('tr-TR')}</span>
                              <span className="text-xs text-gray-500">{new Date(cikis.created_at).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}</span>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="space-y-1">
                              {cikis.items?.map((item, idx) => (
                                <div key={idx} className="flex items-center gap-1 text-sm">
                                  <Package className="h-3 w-3 text-blue-500" />
                                  <span className="font-medium">{item.product_name}</span>
                                </div>
                              ))}
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="space-y-1">
                              {cikis.items?.map((item, idx) => (
                                <div key={idx} className="text-sm font-medium text-blue-600">
                                  {item.quantity} {item.unit}
                                </div>
                              ))}
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="flex items-center gap-1">
                              <User className="h-4 w-4 text-gray-400" />
                              <span>{cikis.teslim_alan || '-'}</span>
                            </div>
                          </TableCell>
                          <TableCell>
                            {cikis.teslim_tarihi ? new Date(cikis.teslim_tarihi).toLocaleDateString('tr-TR') : '-'}
                          </TableCell>
                          <TableCell>
                            <span className="text-sm text-gray-600">{cikis.created_by_name || '-'}</span>
                          </TableCell>
                          <TableCell className="max-w-xs truncate text-sm text-gray-600">
                            {cikis.description || '-'}
                          </TableCell>
                          <TableCell>
                            {/* Talep Belgesi - İlk talep yapılırken eklenen belgeler */}
                            {cikis.teslim_belgeleri && cikis.teslim_belgeleri.length > 0 ? (
                              <div className="flex flex-col gap-1">
                                {cikis.teslim_belgeleri.map((belge, idx) => (
                                  <a 
                                    key={idx}
                                    href={belge.url || belge} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="flex items-center gap-1 text-amber-600 hover:text-amber-800"
                                  >
                                    <FileText className="h-3 w-3" />
                                    <span className="text-xs truncate max-w-[80px]">{belge.name || `Belge ${idx + 1}`}</span>
                                  </a>
                                ))}
                              </div>
                            ) : (
                              <span className="text-xs text-gray-400">-</span>
                            )}
                          </TableCell>
                          <TableCell>
                            {/* Teslim Belgesi - Stok çıkışı yapılırken eklenen belgeler */}
                            {(cikis.teslim_tutanaklari && cikis.teslim_tutanaklari.length > 0) || cikis.teslim_tutanagi_belgesi ? (
                              <div className="flex flex-col gap-1">
                                {cikis.teslim_tutanaklari?.map((belge, idx) => (
                                  <a 
                                    key={idx}
                                    href={belge.url || belge} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="flex items-center gap-1 text-green-600 hover:text-green-800"
                                  >
                                    <FileText className="h-3 w-3" />
                                    <span className="text-xs truncate max-w-[80px]">{belge.name || `Teslim ${idx + 1}`}</span>
                                  </a>
                                ))}
                                {cikis.teslim_tutanagi_belgesi && !cikis.teslim_tutanaklari?.length && (
                                  <a 
                                    href={cikis.teslim_tutanagi_belgesi} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="flex items-center gap-1 text-green-600 hover:text-green-800"
                                  >
                                    <FileText className="h-3 w-3" />
                                    <span className="text-xs">Görüntüle</span>
                                  </a>
                                )}
                              </div>
                            ) : (
                              <span className="text-xs text-gray-400">-</span>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </CardContent>
            </Card>
          </TabsContent>

          {/* Taşınan Raporlar Tab */}
          <TabsContent value="tasinan-raporlar" className="mt-4">
            <Card>
              <CardHeader className="flex flex-row items-center justify-between">
                <CardTitle className="flex items-center gap-2">
                  <FileBarChart className="h-5 w-5 text-amber-600" />
                  Taşınan Raporlar
                </CardTitle>
                <Badge variant="outline" className="text-gray-500">
                  {tasinanRaporlarData.length} rapor
                </Badge>
              </CardHeader>
              <CardContent>
                {tabLoading ? (
                  <div className="flex justify-center py-8"><Loader2 className="h-8 w-8 animate-spin text-amber-600" /></div>
                ) : tasinanRaporlarData.length === 0 ? (
                  <div className="text-center py-8 text-gray-500">
                    <FileBarChart className="h-12 w-12 mx-auto mb-2 opacity-50" />
                    <p>Bu taşerona taşınmış rapor yok</p>
                    <p className="text-sm text-gray-400 mt-1">Raporlar sayfasından &quot;Taşı&quot; butonunu kullanarak rapor taşıyabilirsiniz</p>
                  </div>
                ) : (
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Rapor Türü</TableHead>
                        <TableHead>Başlık</TableHead>
                        <TableHead>Gönderen</TableHead>
                        <TableHead>Tarih</TableHead>
                        <TableHead>Taşınma Tarihi</TableHead>
                        <TableHead>Durum</TableHead>
                        <TableHead>İşlemler</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {tasinanRaporlarData.map(report => (
                        <TableRow key={report.id} data-testid={`moved-report-${report.id}`}>
                          <TableCell>
                            <Badge variant="outline" className="capitalize">
                              {report.report_type === 'daily' ? 'Günlük' : 
                               report.report_type === 'weekly' ? 'Haftalık' :
                               report.report_type === 'monthly' ? 'Aylık' : report.report_type || 'Rapor'}
                            </Badge>
                          </TableCell>
                          <TableCell className="font-medium">{report.title || 'Başlıksız'}</TableCell>
                          <TableCell>{report.from_user?.name || report.created_by_name || '-'}</TableCell>
                          <TableCell>{report.created_at ? new Date(report.created_at).toLocaleDateString('tr-TR') : '-'}</TableCell>
                          <TableCell>
                            {report.moved_at ? (
                              <div className="flex items-center gap-1 text-sm">
                                <ArrowRightLeft className="h-3 w-3 text-blue-500" />
                                {new Date(report.moved_at).toLocaleDateString('tr-TR')}
                              </div>
                            ) : '-'}
                          </TableCell>
                          <TableCell>
                            {report.status === 'completed' ? (
                              <Badge className="bg-green-100 text-green-700">Tamamlandı</Badge>
                            ) : report.status === 'pending' ? (
                              <Badge className="bg-yellow-100 text-yellow-700">Bekliyor</Badge>
                            ) : (
                              <Badge variant="outline">{report.status || 'Bilinmiyor'}</Badge>
                            )}
                          </TableCell>
                          <TableCell>
                            <div className="flex gap-2">
                              <Button 
                                size="sm" 
                                variant="outline" 
                                onClick={() => openItemDetail(report)}
                                data-testid={`view-moved-report-${report.id}`}
                              >
                                <Eye className="h-4 w-4" />
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>

        {/* Hakediş Modal */}
        <Dialog open={hakedisModalOpen} onOpenChange={setHakedisModalOpen}>
          <DialogContent className="max-w-lg">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2"><Receipt className="h-5 w-5 text-amber-600" />Hakediş Ekle</DialogTitle>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label>Hakediş Tarihi</Label>
                <Input type="date" value={hakedisForm.hakedis_date} onChange={(e) => setHakedisForm({...hakedisForm, hakedis_date: e.target.value})} />
              </div>
              <div className="space-y-2">
                <Label>Başlık *</Label>
                <Input value={hakedisForm.title} onChange={(e) => setHakedisForm({...hakedisForm, title: e.target.value})} placeholder="Hakediş başlığı" />
              </div>
              <div className="space-y-2">
                <Label>Hakediş Miktarı (TL) *</Label>
                <div className="relative">
                  <Input 
                    type="number" 
                    value={hakedisForm.amount} 
                    onChange={(e) => setHakedisForm({...hakedisForm, amount: e.target.value})} 
                    placeholder="0.00" 
                    className="pr-12"
                  />
                  <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 font-medium">TL</span>
                </div>
              </div>
              <div className="space-y-2">
                <Label>Hakedişi Yapan</Label>
                <Input value={user?.name || 'Bilinmiyor'} disabled className="bg-gray-50" />
              </div>
              <div className="space-y-2">
                <Label>Açıklama</Label>
                <Textarea value={hakedisForm.description} onChange={(e) => setHakedisForm({...hakedisForm, description: e.target.value})} placeholder="Açıklama..." rows={3} />
              </div>
              <div className="space-y-2">
                <Label>Belgeler</Label>
                <div className="flex items-center gap-2">
                  <Input type="file" multiple onChange={(e) => handleFileUpload(e, setHakedisForm, 'documents')} className="flex-1" />
                </div>
                {hakedisForm.documents.length > 0 && (
                  <div className="mt-2 space-y-1">
                    {hakedisForm.documents.map((doc, i) => (
                      <div key={i} className="flex items-center justify-between bg-gray-50 p-2 rounded text-sm">
                        <span>{doc.name}</span>
                        <Button size="sm" variant="ghost" onClick={() => removeDocument(setHakedisForm, 'documents', i)}><X className="h-4 w-4" /></Button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => setHakedisModalOpen(false)}>İptal</Button>
              <Button onClick={handleCreateHakedis} className="bg-amber-600 hover:bg-amber-700">Ekle</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Sözleşme Modal */}
        <Dialog open={sozlesmeModalOpen} onOpenChange={setSozlesmeModalOpen}>
          <DialogContent className="max-w-lg">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2"><FileSignature className="h-5 w-5 text-amber-600" />Sözleşme Ekle</DialogTitle>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label>Sözleşme Tarihi</Label>
                <Input type="date" value={sozlesmeForm.contract_date} onChange={(e) => setSozlesmeForm({...sozlesmeForm, contract_date: e.target.value})} />
              </div>
              <div className="space-y-2">
                <Label>İş Türü *</Label>
                <Input value={sozlesmeForm.work_type} onChange={(e) => setSozlesmeForm({...sozlesmeForm, work_type: e.target.value})} placeholder="İş türü" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Başlangıç Tarihi</Label>
                  <Input type="date" value={sozlesmeForm.start_date} onChange={(e) => setSozlesmeForm({...sozlesmeForm, start_date: e.target.value})} />
                </div>
                <div className="space-y-2">
                  <Label>Bitiş Tarihi</Label>
                  <Input type="date" value={sozlesmeForm.end_date} onChange={(e) => setSozlesmeForm({...sozlesmeForm, end_date: e.target.value})} />
                </div>
              </div>
              <div className="space-y-2">
                <Label>Belgeler</Label>
                <Input type="file" multiple onChange={(e) => handleFileUpload(e, setSozlesmeForm, 'documents')} />
                {sozlesmeForm.documents.length > 0 && (
                  <div className="mt-2 space-y-1">
                    {sozlesmeForm.documents.map((doc, i) => (
                      <div key={i} className="flex items-center justify-between bg-gray-50 p-2 rounded text-sm">
                        <span>{doc.name}</span>
                        <Button size="sm" variant="ghost" onClick={() => removeDocument(setSozlesmeForm, 'documents', i)}><X className="h-4 w-4" /></Button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => setSozlesmeModalOpen(false)}>İptal</Button>
              <Button onClick={handleCreateSozlesme} className="bg-amber-600 hover:bg-amber-700">Ekle</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* İş Programı Modal */}
        <Dialog open={isProgramiModalOpen} onOpenChange={setIsProgramiModalOpen}>
          <DialogContent className="max-w-lg">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2"><Calendar className="h-5 w-5 text-amber-600" />İş Programı Ekle</DialogTitle>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label>İş Planı Konusu *</Label>
                <Input value={isProgramiForm.subject} onChange={(e) => setIsProgramiForm({...isProgramiForm, subject: e.target.value})} placeholder="Konu" />
              </div>
              <div className="space-y-2">
                <Label>Açıklama</Label>
                <Textarea value={isProgramiForm.description} onChange={(e) => setIsProgramiForm({...isProgramiForm, description: e.target.value})} placeholder="Açıklama..." rows={3} />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Başlama Tarihi</Label>
                  <Input type="date" value={isProgramiForm.start_date} onChange={(e) => setIsProgramiForm({...isProgramiForm, start_date: e.target.value})} />
                </div>
                <div className="space-y-2">
                  <Label>Bitiş Tarihi</Label>
                  <Input type="date" value={isProgramiForm.end_date} onChange={(e) => setIsProgramiForm({...isProgramiForm, end_date: e.target.value})} />
                </div>
              </div>
              <div className="space-y-2">
                <Label>Belgeler</Label>
                <Input type="file" multiple onChange={(e) => handleFileUpload(e, setIsProgramiForm, 'documents')} />
                {isProgramiForm.documents.length > 0 && (
                  <div className="mt-2 space-y-1">
                    {isProgramiForm.documents.map((doc, i) => (
                      <div key={i} className="flex items-center justify-between bg-gray-50 p-2 rounded text-sm">
                        <span>{doc.name}</span>
                        <Button size="sm" variant="ghost" onClick={() => removeDocument(setIsProgramiForm, 'documents', i)}><X className="h-4 w-4" /></Button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => setIsProgramiModalOpen(false)}>İptal</Button>
              <Button onClick={handleCreateIsProgrami} className="bg-amber-600 hover:bg-amber-700">Ekle</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Tutanak Modal */}
        <Dialog open={tutanakModalOpen} onOpenChange={setTutanakModalOpen}>
          <DialogContent className="max-w-lg">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2"><ClipboardList className="h-5 w-5 text-amber-600" />Tutanak Ekle</DialogTitle>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label>Tutanak Tarihi</Label>
                <Input type="date" value={tutanakForm.report_date} onChange={(e) => setTutanakForm({...tutanakForm, report_date: e.target.value})} />
              </div>
              <div className="space-y-2">
                <Label>Başlık *</Label>
                <Input value={tutanakForm.title} onChange={(e) => setTutanakForm({...tutanakForm, title: e.target.value})} placeholder="Tutanak başlığı..." />
              </div>
              <div className="space-y-2">
                <Label>İçerik</Label>
                <Textarea value={tutanakForm.content} onChange={(e) => setTutanakForm({...tutanakForm, content: e.target.value})} placeholder="Tutanak içeriği..." rows={4} />
              </div>
              <div className="space-y-2">
                <Label>Açıklama</Label>
                <Textarea value={tutanakForm.description} onChange={(e) => setTutanakForm({...tutanakForm, description: e.target.value})} placeholder="Ek açıklama..." rows={2} />
              </div>
              <div className="space-y-2">
                <Label>Belgeler</Label>
                <Input type="file" multiple onChange={(e) => handleFileUpload(e, setTutanakForm, 'documents')} />
                {tutanakForm.documents.length > 0 && (
                  <div className="mt-2 space-y-1">
                    {tutanakForm.documents.map((doc, i) => (
                      <div key={i} className="flex items-center justify-between bg-gray-50 p-2 rounded text-sm">
                        <span>{doc.name}</span>
                        <Button size="sm" variant="ghost" onClick={() => removeDocument(setTutanakForm, 'documents', i)}><X className="h-4 w-4" /></Button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => setTutanakModalOpen(false)}>İptal</Button>
              <Button onClick={handleCreateTutanak} className="bg-amber-600 hover:bg-amber-700">Ekle</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* İş Bilgisi Modal */}
        <Dialog open={isBilgisiModalOpen} onOpenChange={setIsBilgisiModalOpen}>
          <DialogContent className="max-w-lg">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2"><FileText className="h-5 w-5 text-amber-600" />İş Bilgisi Ekle</DialogTitle>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label>Tarih</Label>
                <Input type="date" value={isBilgisiForm.report_date} onChange={(e) => setIsBilgisiForm({...isBilgisiForm, report_date: e.target.value})} />
              </div>
              <div className="space-y-2">
                <Label>Başlık *</Label>
                <Input value={isBilgisiForm.title} onChange={(e) => setIsBilgisiForm({...isBilgisiForm, title: e.target.value})} placeholder="İş bilgisi başlığı..." />
              </div>
              <div className="space-y-2">
                <Label>İçerik</Label>
                <Textarea value={isBilgisiForm.content} onChange={(e) => setIsBilgisiForm({...isBilgisiForm, content: e.target.value})} placeholder="İş bilgisi içeriği..." rows={4} />
              </div>
              <div className="space-y-2">
                <Label>Açıklama</Label>
                <Textarea value={isBilgisiForm.description} onChange={(e) => setIsBilgisiForm({...isBilgisiForm, description: e.target.value})} placeholder="Ek açıklama..." rows={2} />
              </div>
              <div className="space-y-2">
                <Label>Belgeler</Label>
                <Input type="file" multiple onChange={(e) => handleFileUpload(e, setIsBilgisiForm, 'documents')} />
                {isBilgisiForm.documents.length > 0 && (
                  <div className="mt-2 space-y-1">
                    {isBilgisiForm.documents.map((doc, i) => (
                      <div key={i} className="flex items-center justify-between bg-gray-50 p-2 rounded text-sm">
                        <span>{doc.name}</span>
                        <Button size="sm" variant="ghost" onClick={() => removeDocument(setIsBilgisiForm, 'documents', i)}><X className="h-4 w-4" /></Button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => setIsBilgisiModalOpen(false)}>İptal</Button>
              <Button onClick={handleCreateIsBilgisi} className="bg-amber-600 hover:bg-amber-700">Ekle</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Detail Modal with Forward */}
        <Dialog open={detailModalOpen} onOpenChange={setDetailModalOpen}>
          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle>Detay</DialogTitle>
            </DialogHeader>
            {selectedItem && (
              <div className="space-y-4 py-4">
                {selectedItem.title && <div><Label className="text-gray-500">Başlık</Label><p className="font-medium">{selectedItem.title}</p></div>}
                {selectedItem.material_name && <div><Label className="text-gray-500">Malzeme Adı</Label><p className="font-medium">{selectedItem.material_name}</p></div>}
                {selectedItem.quantity && (
                  <div className="grid grid-cols-2 gap-4">
                    <div><Label className="text-gray-500">Miktar</Label><p className="font-medium">{selectedItem.quantity}</p></div>
                    <div><Label className="text-gray-500">Birim</Label><p className="font-medium">{selectedItem.unit || '-'}</p></div>
                  </div>
                )}
                {selectedItem.usage_date && <div><Label className="text-gray-500">Kullanım Tarihi</Label><p>{selectedItem.usage_date}</p></div>}
                {selectedItem.work_type && <div><Label className="text-gray-500">İş Türü</Label><p className="font-medium">{selectedItem.work_type}</p></div>}
                {selectedItem.subject && <div><Label className="text-gray-500">Konu</Label><p className="font-medium">{selectedItem.subject}</p></div>}
                {selectedItem.content && <div><Label className="text-gray-500">İçerik</Label><p className="whitespace-pre-wrap">{selectedItem.content}</p></div>}
                {selectedItem.description && <div><Label className="text-gray-500">Açıklama</Label><p className="whitespace-pre-wrap">{selectedItem.description}</p></div>}
                {(selectedItem.hakedis_date || selectedItem.contract_date || selectedItem.report_date) && (
                  <div><Label className="text-gray-500">Tarih</Label><p>{selectedItem.hakedis_date || selectedItem.contract_date || selectedItem.report_date}</p></div>
                )}
                {selectedItem.forwarded && (
                  <div className="bg-green-50 p-3 rounded-lg border border-green-200">
                    <Label className="text-green-700">İletim Durumu</Label>
                    <p className="text-green-600 font-medium">{selectedItem.forwarded_to === 'muhasebe' ? 'Muhasebe\'ye İletildi' : 'Yönetime İletildi'}</p>
                    {selectedItem.forward_note && <p className="text-sm text-gray-600 mt-1">Not: {selectedItem.forward_note}</p>}
                  </div>
                )}
                {(selectedItem.start_date || selectedItem.end_date) && (
                  <div className="grid grid-cols-2 gap-4">
                    {selectedItem.start_date && <div><Label className="text-gray-500">Başlangıç</Label><p>{selectedItem.start_date}</p></div>}
                    {selectedItem.end_date && <div><Label className="text-gray-500">Bitiş</Label><p>{selectedItem.end_date}</p></div>}
                  </div>
                )}
                {selectedItem.contract_amount && (
                  <div>
                    <Label className="text-gray-500">Sözleşme Tutarı</Label>
                    <p className="font-bold text-green-600 text-lg">
                      {Number(selectedItem.contract_amount).toLocaleString('tr-TR')} {selectedItem.currency || 'TL'}
                    </p>
                  </div>
                )}
                {selectedItem.documents?.length > 0 ? (
                  <div>
                    <Label className="text-gray-500">Belgeler</Label>
                    <div className="mt-2 space-y-2">
                      {selectedItem.documents.map((doc, i) => (
                        <div key={i} className="flex items-center justify-between bg-gray-50 p-3 rounded-lg">
                          <div className="flex items-center gap-2">
                            <FileText className="h-4 w-4 text-amber-600" />
                            <span>{doc.name || doc.filename || `Belge ${i + 1}`}</span>
                          </div>
                          <Button size="sm" variant="outline" onClick={() => downloadDocument(doc)} className="gap-1">
                            <Download className="h-4 w-4" />
                            İndir
                          </Button>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div>
                    <Label className="text-gray-500">Belgeler</Label>
                    <p className="text-gray-400 italic mt-1">Henüz belge eklenmemiş</p>
                  </div>
                )}
              </div>
            )}
            <DialogFooter>
              <Button variant="outline" onClick={() => setDetailModalOpen(false)}>Kapat</Button>
              {/* İlet button only for hakediş items */}
              {selectedItem?.hakedis_date && (
                <Button 
                  className="bg-blue-600 hover:bg-blue-700 gap-2"
                  onClick={() => {
                    setDetailModalOpen(false);
                    openForwardModal(selectedItem);
                  }}
                  disabled={selectedItem?.forwarded}
                >
                  <Send className="h-4 w-4" />
                  {selectedItem?.forwarded ? 'İletildi' : 'İlet'}
                </Button>
              )}
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Malzeme Kullanımı Modal */}
        <Dialog open={malzemeModalOpen} onOpenChange={setMalzemeModalOpen}>
          <DialogContent className="max-w-lg">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2"><Package className="h-5 w-5 text-amber-600" />Malzeme Kullanımı Ekle</DialogTitle>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label>Kullanım Tarihi</Label>
                <Input type="date" value={malzemeForm.usage_date} onChange={(e) => setMalzemeForm({...malzemeForm, usage_date: e.target.value})} />
              </div>
              <div className="space-y-2">
                <Label>Malzeme Adı *</Label>
                <Input value={malzemeForm.material_name} onChange={(e) => setMalzemeForm({...malzemeForm, material_name: e.target.value})} placeholder="Malzeme adı" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Miktar</Label>
                  <Input type="number" value={malzemeForm.quantity} onChange={(e) => setMalzemeForm({...malzemeForm, quantity: e.target.value})} placeholder="0" />
                </div>
                <div className="space-y-2">
                  <Label>Birim</Label>
                  <select 
                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    value={malzemeForm.unit} 
                    onChange={(e) => setMalzemeForm({...malzemeForm, unit: e.target.value})}
                  >
                    <option value="adet">Adet</option>
                    <option value="kg">Kg</option>
                    <option value="ton">Ton</option>
                    <option value="metre">Metre</option>
                    <option value="m2">m²</option>
                    <option value="m3">m³</option>
                    <option value="litre">Litre</option>
                    <option value="paket">Paket</option>
                    <option value="kutu">Kutu</option>
                    <option value="torba">Torba</option>
                  </select>
                </div>
              </div>
              <div className="space-y-2">
                <Label>Açıklama</Label>
                <Textarea value={malzemeForm.description} onChange={(e) => setMalzemeForm({...malzemeForm, description: e.target.value})} placeholder="Kullanım detayları..." rows={3} />
              </div>
              <div className="space-y-2">
                <Label>Belgeler</Label>
                <Input type="file" multiple onChange={(e) => handleFileUpload(e, setMalzemeForm, 'documents')} />
                {malzemeForm.documents.length > 0 && (
                  <div className="mt-2 space-y-1">
                    {malzemeForm.documents.map((doc, i) => (
                      <div key={i} className="flex items-center justify-between bg-gray-50 p-2 rounded text-sm">
                        <span>{doc.name}</span>
                        <Button size="sm" variant="ghost" onClick={() => removeDocument(setMalzemeForm, 'documents', i)}><X className="h-4 w-4" /></Button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => setMalzemeModalOpen(false)}>İptal</Button>
              <Button onClick={handleCreateMalzeme} className="bg-amber-600 hover:bg-amber-700">Ekle</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Hakediş İletme (Forward) Modal */}
        <Dialog open={forwardModalOpen} onOpenChange={setForwardModalOpen}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2"><Send className="h-5 w-5 text-blue-600" />Hakediş İlet</DialogTitle>
              <DialogDescription>
                Bu hakedişi hangi birime iletmek istiyorsunuz?
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4 py-4">
              {forwardingItem && (
                <div className="bg-gray-50 p-3 rounded-lg">
                  <p className="font-medium">{forwardingItem.title}</p>
                  <p className="text-sm text-gray-500">Tarih: {forwardingItem.hakedis_date}</p>
                </div>
              )}
              <div className="space-y-2">
                <Label>Hedef Birim *</Label>
                <div className="grid grid-cols-2 gap-3">
                  <Button 
                    variant={forwardTarget === 'muhasebe' ? 'default' : 'outline'} 
                    className={forwardTarget === 'muhasebe' ? 'bg-blue-600 hover:bg-blue-700' : ''}
                    onClick={() => setForwardTarget('muhasebe')}
                  >
                    Muhasebe
                  </Button>
                  <Button 
                    variant={forwardTarget === 'yonetim' ? 'default' : 'outline'} 
                    className={forwardTarget === 'yonetim' ? 'bg-blue-600 hover:bg-blue-700' : ''}
                    onClick={() => setForwardTarget('yonetim')}
                  >
                    Yönetim
                  </Button>
                </div>
              </div>
              <div className="space-y-2">
                <Label>Not (Opsiyonel)</Label>
                <Textarea 
                  value={forwardNote} 
                  onChange={(e) => setForwardNote(e.target.value)} 
                  placeholder="İletim notu..." 
                  rows={3} 
                />
              </div>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => setForwardModalOpen(false)}>İptal</Button>
              <Button 
                onClick={handleForwardHakedis} 
                className="bg-blue-600 hover:bg-blue-700 gap-2"
                disabled={isForwarding}
              >
                {isForwarding ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
                {isForwarding ? 'İletiliyor...' : 'İlet'}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  // Liste görünümü
  return (
    <div className="space-y-6" data-testid="subcontractors-page">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Building2 className="h-8 w-8 text-amber-600" />
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Taşeronlar</h1>
            <p className="text-gray-500">Taşeron firmalarını yönetin</p>
          </div>
        </div>
        <Button onClick={() => { resetForm(); setCreateModalOpen(true); }} className="bg-amber-600 hover:bg-amber-700 gap-2">
          <Plus className="h-4 w-4" />TAŞERON EKLE
        </Button>
      </div>

      {loading ? (
        <div className="flex justify-center py-12"><Loader2 className="h-8 w-8 animate-spin text-amber-600" /></div>
      ) : subcontractors.length === 0 ? (
        <Card>
          <CardContent className="text-center py-12">
            <Building2 className="h-16 w-16 mx-auto mb-4 text-gray-300" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">Henüz taşeron bulunmuyor</h3>
            <p className="text-gray-500 mb-4">İlk taşeronu eklemek için yukarıdaki butonu kullanın</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {subcontractors.map(sub => (
            <Card key={sub.id} className={`hover:shadow-lg transition-shadow cursor-pointer relative ${sub.is_deleted ? 'opacity-60 border-red-200' : ''}`}>
              {/* Yeni kayıt badge'i */}
              {getSubcontractorNewCount(sub.id) > 0 && (
                <Badge className="absolute -top-2 -right-2 h-6 min-w-[24px] px-1 flex items-center justify-center text-xs bg-red-500 text-white z-10 animate-pulse">
                  {getSubcontractorNewCount(sub.id)} yeni
                </Badge>
              )}
              <CardContent className="p-4">
                <div onClick={() => openDetailView(sub)} className="cursor-pointer">
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex items-center gap-3">
                      <div className={`p-2 rounded-lg ${sub.is_deleted ? 'bg-red-100' : 'bg-amber-100'}`}>
                        <Building2 className={`h-6 w-6 ${sub.is_deleted ? 'text-red-600' : 'text-amber-600'}`} />
                      </div>
                      <div>
                        <h3 className="font-semibold text-gray-900">{sub.name || sub.company_name || 'İsimsiz Taşeron'}</h3>
                        <div className="flex items-center gap-2 mt-1">
                          <Badge variant="outline">{sub.contacts?.length || 0} Yetkili</Badge>
                          {sub.is_deleted && <Badge variant="destructive" className="text-xs">Arşivlenmiş</Badge>}
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Firma Bilgileri */}
                  <div className="space-y-1 text-sm mb-3">
                    {sub.completion_requests && sub.completion_requests.length > 0 ? (
                      <div className="flex flex-col gap-1 mb-2">
                        {sub.completion_requests.map((req, i) => (
                          <Badge key={i} variant="outline" className="bg-amber-100 text-amber-700 text-xs py-0 justify-center">
                            {req.requested_by_name} görevi bitirdi
                          </Badge>
                        ))}
                      </div>
                    ) : (
                      <Badge variant="outline" className="bg-green-100 text-green-700 text-xs mb-2 self-start w-fit">Aktif Çalışıyor</Badge>
                    )}

                    {sub.tax_number && sub.tax_number !== 'None' && (
                      <div className="flex items-center gap-2 text-gray-600">
                        <FileText className="h-3 w-3" />
                        <span>VKN: {sub.tax_number}</span>
                      </div>
                    )}
                    {sub.phone && sub.phone !== 'None' && (
                      <div className="flex items-center gap-2 text-gray-600">
                        <Phone className="h-3 w-3" />
                        <span>{sub.phone}</span>
                      </div>
                    )}
                    {sub.email && sub.email !== 'None' && (
                      <div className="flex items-center gap-2 text-gray-600">
                        <Mail className="h-3 w-3" />
                        <span>{sub.email}</span>
                      </div>
                    )}
                    {sub.contact_person && sub.contact_person !== 'None' && (
                      <div className="flex items-center gap-2 text-gray-600">
                        <User className="h-3 w-3" />
                        <span>Yetkili: {sub.contact_person}</span>
                      </div>
                    )}
                  </div>
                  
                  {sub.company_duties && <p className="text-sm text-gray-600 mb-3 line-clamp-2">{sub.company_duties}</p>}
                  {sub.contacts?.length > 0 && (
                    <div className="border-t pt-3 mt-3">
                      <div className="flex items-center gap-2 text-sm text-gray-600">
                        <User className="h-4 w-4" />
                        <span>{sub.contacts[0].name}</span>
                        {sub.contacts[0].title && <span className="text-gray-400">- {sub.contacts[0].title}</span>}
                      </div>
                      {sub.contacts[0].phone && (
                        <div className="flex items-center gap-2 text-sm text-gray-500 mt-1">
                          <Phone className="h-3 w-3" /><span>{sub.contacts[0].phone}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="flex items-center gap-2 mt-4 pt-3 border-t">
                  <Button variant="outline" size="sm" onClick={(e) => { e.stopPropagation(); openEditModal(sub); }} className="flex-1">
                    <Edit className="h-4 w-4 mr-1" />Düzenle
                  </Button>
                  {(!sub.completion_requests || !sub.completion_requests.some(r => r.requested_by === user?.id)) && (
                    <Button variant="outline" size="sm" onClick={(e) => { e.stopPropagation(); handleFinishSubcontractorTask(sub.id); }} className="text-amber-600 hover:text-amber-700 hover:bg-amber-50" title="Görevini Bitirdi Olarak Bildir">
                      <CheckCircle className="h-4 w-4 mr-1" /> Görevi Bitir
                    </Button>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}

      {/* Create Modal */}
      <Dialog open={createModalOpen} onOpenChange={setCreateModalOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Building2 className="h-5 w-5 text-amber-600" />Yeni Taşeron Ekle</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Şirket İsmi *</Label>
              <Input value={formData.company_name} onChange={(e) => setFormData({ ...formData, company_name: e.target.value })} placeholder="Taşeron şirket ismi" />
            </div>
            <div className="space-y-2">
              <Label>Şirket Görevleri / Verdiği Hizmet</Label>
              <Textarea value={formData.provided_service || formData.company_duties} onChange={(e) => setFormData({ ...formData, provided_service: e.target.value, company_duties: e.target.value })} placeholder="Şirketin yapacağı işler veya verdiği hizmet..." rows={3} />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>İşe Başlama Tarihi</Label>
                <Input
                  type="date"
                  value={formData.start_date}
                  onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
                />
              </div>
              <div className="space-y-2">
                <Label>Bitiş Tarihi</Label>
                <Input
                  type="date"
                  value={formData.end_date}
                  onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
                />
              </div>
            </div>

            {/* Custom Fields */}
            <div className="space-y-4 pt-2 border-t">
              <div className="flex items-center justify-between">
                <Label className="text-base font-semibold">Ek Bilgiler (İsteğe Bağlı)</Label>
                <Button 
                  type="button" 
                  variant="outline" 
                  size="sm"
                  onClick={() => {
                    const custom_fields = [...(formData.custom_fields || [])];
                    custom_fields.push({ key: '', value: '' });
                    setFormData({ ...formData, custom_fields });
                  }}
                  className="gap-1 h-8 text-xs"
                >
                  <Plus className="h-3 w-3" /> Bilgi Ekle
                </Button>
              </div>
              
              {(formData.custom_fields || []).map((field, index) => (
                <div key={index} className="flex items-center gap-2">
                  <Input 
                    placeholder="Başlık (Örn: SGK No)"
                    value={field.key}
                    onChange={(e) => {
                      const custom_fields = [...formData.custom_fields];
                      custom_fields[index].key = e.target.value;
                      setFormData({ ...formData, custom_fields });
                    }}
                    className="flex-1"
                  />
                  <Input 
                    placeholder="Değer (Örn: 12345)"
                    value={field.value}
                    onChange={(e) => {
                      const custom_fields = [...formData.custom_fields];
                      custom_fields[index].value = e.target.value;
                      setFormData({ ...formData, custom_fields });
                    }}
                    className="flex-1"
                  />
                  <Button 
                    type="button" 
                    variant="ghost" 
                    size="sm" 
                    className="h-10 w-10 p-0 text-red-500"
                    onClick={() => {
                      const custom_fields = [...formData.custom_fields];
                      custom_fields.splice(index, 1);
                      setFormData({ ...formData, custom_fields });
                    }}
                  >
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              ))}
            </div>

            <div className="space-y-3 pt-2 border-t">
              <div className="flex items-center justify-between">
                <Label>Yetkili Kişiler</Label>
                <Button type="button" variant="outline" size="sm" onClick={addContact} className="gap-1"><Plus className="h-4 w-4" />Yetkili Ekle</Button>
              </div>
              {formData.contacts.map((contact, index) => (
                <Card key={index} className="p-4">
                  <div className="flex items-start justify-between mb-3">
                    <span className="text-sm font-medium text-gray-600">Yetkili {index + 1}</span>
                    {formData.contacts.length > 1 && (
                      <Button type="button" variant="ghost" size="sm" onClick={() => removeContact(index)} className="h-6 w-6 p-0 text-red-500"><X className="h-4 w-4" /></Button>
                    )}
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div className="space-y-1"><Label className="text-xs">Ad Soyad</Label><Input value={contact.name} onChange={(e) => updateContact(index, 'name', e.target.value)} placeholder="Ad Soyad" /></div>
                    <div className="space-y-1"><Label className="text-xs">Görev</Label><Input value={contact.title} onChange={(e) => updateContact(index, 'title', e.target.value)} placeholder="Görev" /></div>
                    <div className="space-y-1"><Label className="text-xs">Telefon</Label><Input value={contact.phone} onChange={(e) => updateContact(index, 'phone', e.target.value)} placeholder="05XX XXX XX XX" /></div>
                    <div className="space-y-1"><Label className="text-xs">E-posta</Label><Input value={contact.email} onChange={(e) => updateContact(index, 'email', e.target.value)} placeholder="email@sirket.com" type="email" /></div>
                  </div>
                </Card>
              ))}
            </div>

            {/* Taşeronu Görebilecek Kullanıcılar */}
            <div className="space-y-2 border-t pt-4">
              <div className="flex items-center justify-between">
                <Label className="flex items-center gap-2">
                  <Users className="h-4 w-4 text-blue-600" />
                  Bu Taşeronu Görebilecek Kullanıcılar
                </Label>
                <div className="flex gap-2">
                  <Button type="button" variant="outline" size="sm" onClick={selectAllVisibleUsers}>Tümünü Seç</Button>
                  <Button type="button" variant="outline" size="sm" onClick={clearVisibleUsers}>Temizle</Button>
                </div>
              </div>
              <p className="text-xs text-gray-500">Boş bırakılırsa sadece şube yöneticisi görebilir</p>
              <ScrollArea className="h-32 border rounded-lg p-2">
                {workPanelUsers.length === 0 ? (
                  <p className="text-sm text-gray-500 text-center py-4">İş paneli kullanıcısı bulunamadı</p>
                ) : (
                  <div className="space-y-2">
                    {workPanelUsers.map(user => (
                      <div key={user.id} className="flex items-center space-x-2 p-1 hover:bg-gray-50 rounded">
                        <Checkbox
                          id={`create-visible-${user.id}`}
                          checked={formData.visible_to_users.includes(user.id)}
                          onCheckedChange={() => toggleUserVisibility(user.id)}
                        />
                        <label htmlFor={`create-visible-${user.id}`} className="text-sm cursor-pointer flex-1">
                          {user.name}
                          {user.position_name && <span className="text-xs text-gray-400 ml-2">({user.position_name})</span>}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </ScrollArea>
              {formData.visible_to_users.length > 0 && (
                <div className="flex flex-wrap gap-1">
                  {formData.visible_to_users.map(userId => {
                    const user = workPanelUsers.find(u => u.id === userId);
                    return user ? <Badge key={userId} variant="secondary" className="text-xs">{user.name}</Badge> : null;
                  })}
                </div>
              )}
            </div>

            {/* Sözleşme Tabını Görebilecek Kullanıcılar */}
            <div className="space-y-2 border-t pt-4">
              <div className="flex items-center justify-between">
                <Label className="flex items-center gap-2">
                  <FileSignature className="h-4 w-4 text-amber-600" />
                  Sözleşme Tabını Görebilecek Kullanıcılar
                </Label>
                <div className="flex gap-2">
                  <Button type="button" variant="outline" size="sm" onClick={selectAllContractViewers}>Tümünü Seç</Button>
                  <Button type="button" variant="outline" size="sm" onClick={clearContractViewers}>Temizle</Button>
                </div>
              </div>
              <p className="text-xs text-gray-500">Boş bırakılırsa kimse sözleşme tabını göremez (şube yöneticisi hariç)</p>
              <ScrollArea className="h-32 border rounded-lg p-2">
                {workPanelUsers.length === 0 ? (
                  <p className="text-sm text-gray-500 text-center py-4">İş paneli kullanıcısı bulunamadı</p>
                ) : (
                  <div className="space-y-2">
                    {workPanelUsers.map(user => (
                      <div key={user.id} className="flex items-center space-x-2 p-1 hover:bg-gray-50 rounded">
                        <Checkbox
                          id={`create-contract-${user.id}`}
                          checked={formData.contract_viewers.includes(user.id)}
                          onCheckedChange={() => toggleContractViewer(user.id)}
                        />
                        <label htmlFor={`create-contract-${user.id}`} className="text-sm cursor-pointer flex-1">
                          {user.name}
                          {user.position_name && <span className="text-xs text-gray-400 ml-2">({user.position_name})</span>}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </ScrollArea>
              {formData.contract_viewers.length > 0 && (
                <div className="flex flex-wrap gap-1">
                  {formData.contract_viewers.map(userId => {
                    const user = workPanelUsers.find(u => u.id === userId);
                    return user ? <Badge key={userId} variant="outline" className="text-xs border-amber-500 text-amber-700">{user.name}</Badge> : null;
                  })}
                </div>
              )}
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setCreateModalOpen(false)}>İptal</Button>
            <Button onClick={handleCreateSubcontractor} className="bg-amber-600 hover:bg-amber-700">Ekle</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Edit Modal */}
      <Dialog open={editModalOpen} onOpenChange={setEditModalOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Edit className="h-5 w-5 text-amber-600" />Taşeron Düzenle</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label>Şirket İsmi *</Label>
              <Input value={formData.company_name} onChange={(e) => setFormData({ ...formData, company_name: e.target.value })} placeholder="Taşeron şirket ismi" />
            </div>
            <div className="space-y-2">
              <Label>Şirket Görevleri / Verdiği Hizmet</Label>
              <Textarea value={formData.provided_service || formData.company_duties} onChange={(e) => setFormData({ ...formData, provided_service: e.target.value, company_duties: e.target.value })} placeholder="Şirketin yapacağı işler veya verdiği hizmet..." rows={3} />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>İşe Başlama Tarihi</Label>
                <Input
                  type="date"
                  value={formData.start_date}
                  onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
                />
              </div>
              <div className="space-y-2">
                <Label>Bitiş Tarihi</Label>
                <Input
                  type="date"
                  value={formData.end_date}
                  onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
                />
              </div>
            </div>

            {/* Custom Fields */}
            <div className="space-y-4 pt-2 border-t">
              <div className="flex items-center justify-between">
                <Label className="text-base font-semibold">Ek Bilgiler (İsteğe Bağlı)</Label>
                <Button 
                  type="button" 
                  variant="outline" 
                  size="sm"
                  onClick={() => {
                    const custom_fields = [...(formData.custom_fields || [])];
                    custom_fields.push({ key: '', value: '' });
                    setFormData({ ...formData, custom_fields });
                  }}
                  className="gap-1 h-8 text-xs"
                >
                  <Plus className="h-3 w-3" /> Bilgi Ekle
                </Button>
              </div>
              
              {(formData.custom_fields || []).map((field, index) => (
                <div key={index} className="flex items-center gap-2">
                  <Input 
                    placeholder="Başlık (Örn: SGK No)"
                    value={field.key}
                    onChange={(e) => {
                      const custom_fields = [...formData.custom_fields];
                      custom_fields[index].key = e.target.value;
                      setFormData({ ...formData, custom_fields });
                    }}
                    className="flex-1"
                  />
                  <Input 
                    placeholder="Değer (Örn: 12345)"
                    value={field.value}
                    onChange={(e) => {
                      const custom_fields = [...formData.custom_fields];
                      custom_fields[index].value = e.target.value;
                      setFormData({ ...formData, custom_fields });
                    }}
                    className="flex-1"
                  />
                  <Button 
                    type="button" 
                    variant="ghost" 
                    size="sm" 
                    className="h-10 w-10 p-0 text-red-500"
                    onClick={() => {
                      const custom_fields = [...formData.custom_fields];
                      custom_fields.splice(index, 1);
                      setFormData({ ...formData, custom_fields });
                    }}
                  >
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              ))}
            </div>

            <div className="space-y-3 pt-2 border-t">
              <div className="flex items-center justify-between">
                <Label>Yetkili Kişiler</Label>
                <Button type="button" variant="outline" size="sm" onClick={addContact} className="gap-1"><Plus className="h-4 w-4" />Yetkili Ekle</Button>
              </div>
              {formData.contacts.map((contact, index) => (
                <Card key={index} className="p-4">
                  <div className="flex items-start justify-between mb-3">
                    <span className="text-sm font-medium text-gray-600">Yetkili {index + 1}</span>
                    {formData.contacts.length > 1 && (
                      <Button type="button" variant="ghost" size="sm" onClick={() => removeContact(index)} className="h-6 w-6 p-0 text-red-500"><X className="h-4 w-4" /></Button>
                    )}
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div className="space-y-1"><Label className="text-xs">Ad Soyad</Label><Input value={contact.name} onChange={(e) => updateContact(index, 'name', e.target.value)} placeholder="Ad Soyad" /></div>
                    <div className="space-y-1"><Label className="text-xs">Görev</Label><Input value={contact.title} onChange={(e) => updateContact(index, 'title', e.target.value)} placeholder="Görev" /></div>
                    <div className="space-y-1"><Label className="text-xs">Telefon</Label><Input value={contact.phone} onChange={(e) => updateContact(index, 'phone', e.target.value)} placeholder="05XX XXX XX XX" /></div>
                    <div className="space-y-1"><Label className="text-xs">E-posta</Label><Input value={contact.email} onChange={(e) => updateContact(index, 'email', e.target.value)} placeholder="email@sirket.com" type="email" /></div>
                  </div>
                </Card>
              ))}
            </div>

            {/* Taşeronu Görebilecek Kullanıcılar */}
            <div className="space-y-2 border-t pt-4">
              <div className="flex items-center justify-between">
                <Label className="flex items-center gap-2">
                  <Users className="h-4 w-4 text-blue-600" />
                  Bu Taşeronu Görebilecek Kullanıcılar
                </Label>
                <div className="flex gap-2">
                  <Button type="button" variant="outline" size="sm" onClick={selectAllVisibleUsers}>Tümünü Seç</Button>
                  <Button type="button" variant="outline" size="sm" onClick={clearVisibleUsers}>Temizle</Button>
                </div>
              </div>
              <p className="text-xs text-gray-500">Boş bırakılırsa sadece şube yöneticisi görebilir</p>
              <ScrollArea className="h-32 border rounded-lg p-2">
                {workPanelUsers.length === 0 ? (
                  <p className="text-sm text-gray-500 text-center py-4">İş paneli kullanıcısı bulunamadı</p>
                ) : (
                  <div className="space-y-2">
                    {workPanelUsers.map(user => (
                      <div key={user.id} className="flex items-center space-x-2 p-1 hover:bg-gray-50 rounded">
                        <Checkbox
                          id={`edit-visible-${user.id}`}
                          checked={formData.visible_to_users.includes(user.id)}
                          onCheckedChange={() => toggleUserVisibility(user.id)}
                        />
                        <label htmlFor={`edit-visible-${user.id}`} className="text-sm cursor-pointer flex-1">
                          {user.name}
                          {user.position_name && <span className="text-xs text-gray-400 ml-2">({user.position_name})</span>}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </ScrollArea>
              {formData.visible_to_users.length > 0 && (
                <div className="flex flex-wrap gap-1">
                  {formData.visible_to_users.map(userId => {
                    const user = workPanelUsers.find(u => u.id === userId);
                    return user ? <Badge key={userId} variant="secondary" className="text-xs">{user.name}</Badge> : null;
                  })}
                </div>
              )}
            </div>

            {/* Sözleşme Tabını Görebilecek Kullanıcılar */}
            <div className="space-y-2 border-t pt-4">
              <div className="flex items-center justify-between">
                <Label className="flex items-center gap-2">
                  <FileSignature className="h-4 w-4 text-amber-600" />
                  Sözleşme Tabını Görebilecek Kullanıcılar
                </Label>
                <div className="flex gap-2">
                  <Button type="button" variant="outline" size="sm" onClick={selectAllContractViewers}>Tümünü Seç</Button>
                  <Button type="button" variant="outline" size="sm" onClick={clearContractViewers}>Temizle</Button>
                </div>
              </div>
              <p className="text-xs text-gray-500">Boş bırakılırsa kimse sözleşme tabını göremez (şube yöneticisi hariç)</p>
              <ScrollArea className="h-32 border rounded-lg p-2">
                {workPanelUsers.length === 0 ? (
                  <p className="text-sm text-gray-500 text-center py-4">İş paneli kullanıcısı bulunamadı</p>
                ) : (
                  <div className="space-y-2">
                    {workPanelUsers.map(user => (
                      <div key={user.id} className="flex items-center space-x-2 p-1 hover:bg-gray-50 rounded">
                        <Checkbox
                          id={`edit-contract-${user.id}`}
                          checked={formData.contract_viewers.includes(user.id)}
                          onCheckedChange={() => toggleContractViewer(user.id)}
                        />
                        <label htmlFor={`edit-contract-${user.id}`} className="text-sm cursor-pointer flex-1">
                          {user.name}
                          {user.position_name && <span className="text-xs text-gray-400 ml-2">({user.position_name})</span>}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </ScrollArea>
              {formData.contract_viewers.length > 0 && (
                <div className="flex flex-wrap gap-1">
                  {formData.contract_viewers.map(userId => {
                    const user = workPanelUsers.find(u => u.id === userId);
                    return user ? <Badge key={userId} variant="outline" className="text-xs border-amber-500 text-amber-700">{user.name}</Badge> : null;
                  })}
                </div>
              )}
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setEditModalOpen(false)}>İptal</Button>
            <Button onClick={handleEditSubcontractor} className="bg-amber-600 hover:bg-amber-700">Kaydet</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

    </div>
  );
};

export default BranchSubcontractors;
